/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import 'isomorphic-fetch';

import { attemptRequest } from '../utilities/redux-request-deduplication';

import output from '../utilities/output';

// Helpers
function checkStatus(response) {
  if (response.status >= 200 && response.status < 300) {
    return response;
  }

  const error = new Error(response.statusText);
  error.response = response;
  throw error;
}

// To interact with the fuel proxy provided by your node server send a url that begins with /fuelapi/
// Using a named export here as this is a template file that will likely have
// additional exports added to it. For true single-export files the default
// export rule should be followed.

/* eslint-disable import/prefer-default-export */
export function createFetchAction(actionName, url, options = {}) {
  const { requestId, payload = {}, ...rest } = options;

  return function (dispatch) {
    attemptRequest(
      requestId || url,
      {
        begin: () => ({
          type: actionName,
          payload,
        }),
        success: (response) => ({
          type: actionName,
          payload: {
            ...payload,
            response,
          },
        }),
        failure: (error) => {
          output.error(error);

          return {
            type: actionName,
            error,
            payload,
          };
        },
      },
      // Send cookies to the node server. Override per-request if needed for CORS
      () =>
        fetch(url, { credentials: 'same-origin', ...rest }) // eslint-disable-line no-undef
          .then(checkStatus)
          .then((response) => response.json()),
      dispatch
    );
  };
}
